export default {
  title: {
    jobPosterManagement: '职位海报管理',
    jobPosterAmbassadorUpload: '上传宣传大使',
    jobPosterAmbassadorAdd: '添加宣传大使',
    jobPosterAmbassadorEdit: '编辑宣传大使'
  },
  label: {
    companyName: '公司名称',
    on: '开',
    off: '关',
    add: '添加',
    posterSize: '海报尺寸',
    shareCoverImage: '分享封面图',
    uploadFile: '上传',
    imgRecommended: '建议尺寸：{recommendedSize}',
    sameAsVideoSize: '与视频同宽高',
    fieldValue: '字段名',
    operation: '操作',
    jobName: '职位名称',
    city: '城市',
    font: '字体',
    size: '大小',
    qrCodeSize: '二维码尺寸',
    qrCodePosition: '二维码位置',
    qrCodeDisplay: '二维码显示',
    roundedCorners: '圆角',
    haveLogo: '公司标志',
    yes: '是',
    no: '否',
    save: '保存',
    preview: '预览',
    previewPicture: '预览图片',
    previewVideo: '预览视频',
    acceptImageType: '*请上传 jpg/jpeg/png 格式文件.',
    acceptImageSize: '*图片大小小于{imageMaxSize}MB.',
    isEnable: '是否启用',
    acceptVideoType: '*请上传 mp4 格式文件',
    acceptVideoSize: '*请上传时长小于{videoMaxDuration}秒，大小小于{videoMaxSize}MB的文件',
    posterType: '海报格式',
    posterTitle: '海报名称',
    imageSize: '图片尺寸',
    imgPoster: '图片',
    videoPoster: '视频',
    posterVideo: '海报视频',
    currentVideoSize: '当前视频尺寸',
    videoTopImage: '视频顶部水印图片',
    videoBottomImage: '视频底部水印图片',
    videoBindImage: '视频尾部拼接图片',
    align: {
      center: '居中对齐'
    },
    distinct: '区',
    address: '地址',
    email: '邮箱',
    phone: '手机',
    name: '姓名',
    excelInput: 'EXCEL文件: ',
    ambassadorStatus: '状态',
    addAmbassador: '添加宣传大使',
    editAmbassador: '编辑宣传大使',
    companyJobPoster: '公司海报',
    ambassadorJobPoster: '我的海报',
    customJobPoster: '新增海报',
    instructionsJobPoster: '海报指导',
    jobPosterShowType: '海报类型',
    followTheme: '跟随主题'
  },
  message: {
    wrongImageType: '请上传图片文件！',
    wrongImageSize: '请上传小于{size}MB的文件！',
    wrongVideoType: '请上传mp4视频文件！',
    wrongVideoSize: '请上传小于{size}MB且时长小于{duration}秒的mp4视频文件',
    bindImageTip: '水印图片建议与视频同宽,拼接图片建议与视频同宽高',
    uploading: '上传中……',
    compressing: '压缩中……',
    generating: '生成中……',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    operateFailed: '操作失败，请重试',
    // uploadToCdnError: '图片保存至服务器失败，请稍后再试',
    uploadToCdnError: '图片上传失败，请尝试重新上传',
    noPosterTitle: '请输入海报名称，不超过60个字符',
    noPosterVideo: '请先上传海报视频',
    noPosterBgImage: '请先上传海报底图',
    noPosterShareImage: '请先上传分享按钮图',
    posterBgSizeError: '海报的宽和高不能设置为0',
    posterSaveError: '保存失败，请重试',
    posterSaveSuccess: '保存成功',
    uploadTip: '只能上传excel文件',
    uploadError: '上传失败,请重新上传',
    uploadAmbassadorSuccess: '上传成功{successCount}条， 失败{failCount}条',
    missEmailOrPhone: '邮箱和手机至少填写一个',
    deleteAmbassadorPosterSuccess: '删除成功',
    deleteAmbassadorPosterFail: '删除出错啦，请重试'
  },
  btn: {
    selectFile: '浏览',
    upload: '上传宣传大使',
    downloadTemplate: '下载模板',
    fleshData: '刷新',
    cancelUpload: '取消',
    ConfirmUpload: '确认',
    addAmbassador: '添加',
    editImgJobPoster: '上传图片',
    editVideoJobPoster: '上传视频'
  },
  placeholder: {
    name: '请输入姓名',
    phone: '请输入手机',
    email: '请输入邮箱'
  },
  jobPosterShowType: {
    COMMON: '公司海报',
    CUSTOM: '宣传大使海报',
    INSTRUCTIONS: '海报指导'
  }
}
